import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.number.constructor";
// 页面JS逻辑文件
import databus, { Origins } from '@ykz/ykz-http/core';
import headerBox from "./components/headerBox.vue";
import empty from "./components/empty.vue";
import productList from "./components/productList.vue";
import carefullyBox from "./components/carefullyChosen.vue";
import myShopFooter from "@/components/my_shop_nav.vue";
import extension from "./components/extension.vue";
import { getTimeOject, getTimeObjByStame, updateUrlParam, toQueryString, toast, showLoading, hideLoading } from '@ykz/ykz-util/base';
import { getProductLink as _getProductLink } from "@/util/common";
var DEFAULT_PAGESIZE = 20; //默认每页请求数
var CAREFULLY_DEFAULT_PAGESIZE = 30; //精选每页请求数
var page = {
  name: "page",
  data: function data() {
    return {
      weChatId: window.getUrlParams("weChatId"),
      shopPromotion: window.getUrlParams("promotion") || sessionStorage.getItem("isShop_promotion") || "",
      shopName: "",
      oldData: null,
      //历史参数
      timeStamp: "",
      //时间戳
      user: null,
      //用户信息
      currentCity: {
        //当前选中城市
        provinceCode: "",
        provinceName: "",
        cityCode: "",
        cityName: "",
        districtCode: "",
        districtName: "",
        longitude: "",
        latitude: ""
      },
      localCity: {
        //用户所在位置的定位
        longitude: "",
        latitude: "",
        cityName: "",
        provinceName: ""
      },
      page: {
        size: DEFAULT_PAGESIZE,
        index: 1,
        status: -1,
        empty: false,
        end: false
      },
      product: {
        list: [],
        //产品列表
        condition: "",
        //tabid
        showNav: false //显示导航栏
      },

      productAjax: {},
      carefullyProductAjax: {},
      countDownList: [],
      timer: null,
      beforeTimeStame: 0,
      //上一个时间戳
      nowTimeStame: 1,
      //当前时间戳

      carefullyData: {
        //店铺精选数据
        list: [],
        //列表
        empty: false,
        //是否是空的
        removeNum: 0,
        //删除数
        pageIndex: 1,
        pageSize: CAREFULLY_DEFAULT_PAGESIZE,
        end: false,
        //是否展示
        show: false
      },
      isEditer: false,
      //是否是店铺归属者
      onlyShowSelected: 0,
      urlPreview: window.getUrlParams("inPreview") || false
    };
  },
  components: {
    headerBox: headerBox,
    empty: empty,
    carefullyBox: carefullyBox,
    productList: productList,
    myShopFooter: myShopFooter,
    extension: extension
  },
  computed: {
    addMoreText: function addMoreText() {
      switch (+this.page.status) {
        case -1:
          return "";
        case 0:
          return this.product.list.length > 0 ? "查看更多数据" : "";
        case 1:
          return this.product.list.length > 0 ? "加载中..." : "";
        case 2:
          return this.product.list.length > 5 ? "已加载完" : "";
      }
    },
    //是否处于预览状态(非店铺主人或者点击预览)
    inPreview: function inPreview() {
      return !this.isEditer || this.urlPreview;
    },
    showProductListTitle: function showProductListTitle() {
      return this.product.condition == "-5" && (this.isEditer && !this.urlPreview || this.carefullyData.list.length > 0 || this.onlyShowSelected); //这里onlyShowSelected判断是为了兼容UI的无数据显示
    }
  },

  methods: {
    // 获取店铺名称
    getShopName: function getShopName() {
      var that = this;
      databus({
        url: "/apiv2/marketing/getShopName",
        data: {
          promotion: that.shopPromotion
        },
        success: function success(data) {
          if (data.code == 1000 && data.bcode == 100) {
            that.shopName = data.content.shopName;
            window.document.title = that.shopName;
          }
        },
        complete: function complete() {
          that.setShare();
        }
      });
    },
    //页面滚动事件
    winScroll: function winScroll(e) {
      !this.onlyShowSelected && this.$refs.headerBox.pageScroll();
      var boxHeight = e.target.clientHeight;
      var contentHeight = e.target.children[0].clientHeight;
      var scrollTop = e.target.scrollTop;
      if (this.page.status == 0 && scrollTop + boxHeight >= contentHeight - 2) {
        this.page.index++;
        this.getProductList();
      }
    },
    // 切换tab
    switchNav: function switchNav(option) {
      if (option.type == 2) {
        this.reSetData();
      }
      if (option.id == -5) {
        this.getCarefullyProductList();
      }
      this.product.condition = option.id;
      this.getProductList();
    },
    //切换城市
    switchCity: function switchCity(option) {
      switch (option.type) {
        case 1:
          this.currentCity = $.extend(this.currentCity, option.currentCity);
          this.localCity = $.extend(this.localCity, option.gpsCity);
          this.getOldData();
          break;
        case 2:
          this.currentCity = $.extend(this.currentCity, option.currentCity);
          this.reSetData();
          this.getProductList();
          if (this.product.condition == -5) {
            this.getCarefullyProductList();
          }
          break;
      }
    },
    //获取产品列表
    getProductList: function getProductList() {
      var that = this;
      that.productAjax.abort && that.productAjax.abort();
      databus({
        url: "apiv2/marketing/getGoodsByTagId",
        noLongLatitude: true,
        data: $.extend({
          tagId: -1,
          activeType: that.product.condition,
          province: that.currentCity.provinceName,
          userDistrict: that.currentCity.districtName,
          city: that.currentCity.cityName,
          orderRule: 3,
          source: 0,
          page: that.page.index,
          size: that.page.size,
          isShop: 1
        }, that.getGPSData()),
        abort: function abort(c) {
          that.productAjax.abort = c;
        },
        success: function success(data) {
          that.timeStamp = data.timeStamp;
          if (data.code == 1000 && data.bcode == 100) {
            if (data.content.list.length > 0) {
              data.content.list.map(function (item) {
                if (that.canAddThisProduct(that.product.list, item)) {
                  data.content.list.map(function (item) {
                    var newItem = $.extend({}, that.extendProductData({
                      item: item,
                      timeStamp: that.timeStamp
                    }));
                    that.product.list.push(item);
                    if (newItem.isActivity) {
                      that.countDownList.push(newItem);
                    }
                  });
                }
              });
            }
          }
          that.page.status = 0;
          if (that.page.index == 1 && that.product.list.length == 0) {
            that.page.empty = true;
            that.page.status = -1;
          }
          if (that.page.index >= Math.ceil(data.content.count / that.page.size)) {
            that.page.status = 2;
          }

          //从详情页返回指定
          if (that.page.size > DEFAULT_PAGESIZE) {
            that.page.index = Math.ceil(that.page.size / DEFAULT_PAGESIZE);
            that.page.size = DEFAULT_PAGESIZE;
          }
        },
        error: function error() {
          that.page.status = 0;
        },
        beforeSend: function beforeSend() {
          showLoading();
          that.page.status = 1;
        },
        complete: function complete() {
          hideLoading();
        }
      });
    },
    //获取店铺推荐产品列表
    getCarefullyProductList: function getCarefullyProductList() {
      var that = this;
      that.carefullyProductAjax.abort && that.carefullyProductAjax.abort();
      databus({
        type: "get",
        origin: Origins.API_GOOD,
        url: "api/products/shopCollectList",
        noLongLatitude: true,
        data: $.extend({
          province: that.currentCity.provinceName,
          city: that.currentCity.cityName,
          page: that.carefullyData.pageIndex,
          size: that.carefullyData.pageSize,
          historyCount: that.carefullyData.removeNum,
          shopPromotion: that.shopPromotion
        }, that.getGPSData()),
        abort: function abort(c) {
          that.carefullyProductAjax.abort = c;
        },
        success: function success(data) {
          that.timeStamp = data.timeStamp;
          that.carefullyData.list = [];
          if (data.code == 1000 && data.bcode == 100) {
            if (data.content.list.length > 0) {
              data.content.list.map(function (item) {
                if (that.canAddThisProduct(that.carefullyData.list, item)) {
                  data.content.list.map(function (item) {
                    var newItem = $.extend({}, that.extendProductData({
                      item: item,
                      timeStamp: that.timeStamp
                    }));
                    that.carefullyData.list.push(item);
                    if (newItem.isActivity) {
                      that.countDownList.push(newItem);
                    }
                  });
                }
              });
            }
          }
          that.carefullyData.empty = that.carefullyData.list.length > 0 ? false : true;
        },
        beforeSend: function beforeSend() {
          showLoading();
        },
        complete: function complete() {
          that.carefullyData.show = true;
          hideLoading();
        }
      });
    },
    //获取用户信息数据
    getUserData: function getUserData(data) {
      var that = this;
      showLoading({
        cover: true,
        opacity: 0
      });
      if (data) {
        if (data.code == 1000 && data.bcode == 100) {
          that.user = data.content;
        }
      }
    },
    //判断用户是否店主
    checkShopkeeper: function checkShopkeeper() {
      var that = this;
      databus({
        type: "get",
        url: "/apiv2/marketing/checkShopkeeper",
        data: {
          promotion: that.shopPromotion
        },
        success: function success(data) {
          if (data.code == 1000 && data.bcode == 100) {
            that.isEditer = data.content.isShopkeeper;
            that.onlyShowSelected = data.content.onlyShowSelected; //增加分享设置开关控制只显示店铺精选
            that.isEditer && window.sessionStorage.setItem("is_shop_keeper", true);
          }
        }
      });
    },
    //获取历史数据
    getOldData: function getOldData() {
      var parentChildData = window.sessionStorage.getItem("my_shop_data");
      window.sessionStorage.removeItem("my_shop_data");
      if (parentChildData) {
        this.oldData = JSON.parse(parentChildData);
      }
      if (this.oldData && this.currentCity.cityName != this.oldData.cityName) {
        this.oldData = null;
      }
      if (this.oldData && this.oldData.pageSize) {
        this.page.size = this.oldData.pageSize;
      }
      if (this.oldData && this.oldData.condition) {
        this.product.condition = this.oldData.condition;
      }
      this.product.showNav = true;
    },
    saveOldData: function saveOldData(saveItemId) {
      var oldData = {
        cityName: this.currentCity.cityName,
        //tab的对应上产品数据
        condition: this.product.condition,
        pageSize: this.page.index * DEFAULT_PAGESIZE,
        tagId: this.tagId,
        goodsId: saveItemId || ""
      };
      window.sessionStorage.setItem("my_shop_data", JSON.stringify(oldData));
    },
    //滚动到指定位置(删除旧数据)
    toTargetGoods: function toTargetGoods(option) {
      if (option.top > 0) {
        $("#page").scrollTop(option.top);
      }
      //删除历史数据
      if (this.oldData && String(this.oldData.goodsId).indexOf(option.from) >= 0) {
        this.oldData = null;
      }
    },
    //数据重置
    reSetData: function reSetData() {
      this.product.list = [];
      this.page = $.extend(this.page, {
        size: DEFAULT_PAGESIZE,
        index: 1,
        status: -1,
        empty: false,
        end: false
      });
      this.carefullyData = $.extend(this.carefullyData, {
        list: [],
        empty: false,
        removeNum: 0,
        pageIndex: 1,
        pageSize: CAREFULLY_DEFAULT_PAGESIZE,
        end: false,
        show: false
      });
    },
    //是否返回gps数据
    getGPSData: function getGPSData() {
      var gpsData = {};
      if (this.product.condition == 6 || this.theSameCity(this.localCity.cityName, this.currentCity.cityName)) {
        gpsData = {
          gpsCity: this.localCity.cityName,
          gpsProvince: this.localCity.provinceName,
          longitude: this.localCity.longitude,
          latitude: this.localCity.latitude
        };
      }
      return gpsData;
    },
    //拓展产品数据
    extendProductData: function extendProductData(option) {
      var item = option.item;
      if (!item.hasExtend) {
        item.hasExtend = true;
        this.productAddress(item);
        this.productPrice(item);

        //默认常规产品状态(1:抢购未开始，2：抢购中 3:抢购已结束)
        item.status = 0;
        //当前服务器时间
        item.serverTime = option.timeStamp;
        if (this.isEditer) {
          this.productComm(item);
        }

        //抢购状态与倒计时文案
        if (item.isActivity) {
          item.startTimeObj = getTimeObjByStame(item.startTime);
          item.endTimeObj = getTimeObjByStame(item.endTime);
          this.initProductTime(item);
        }
      }
      return item;
    },
    //设置地址
    productAddress: function productAddress(item) {
      item.address = "";
      if (!this.theSameCity(this.localCity.cityName, this.currentCity.cityName)) {
        item.distance = "";
      }
      //产品类型去掉地址
      if (~~item.cateId == 7 || !item.city) {
        item.business = "";
        return;
      } else {
        //与选中城市相同优先展示顺序：区，街道(兼容部分没有区)，市
        if (this.theSameCity(this.currentCity.cityName, item.city)) {
          item.address = item.districtName || item.streetName || item.city;
        } else {
          item.business = "";
          item.address = item.city;
        }
      }
      if (item.distance) {
        var num = Number(item.distance);
        if (item.distance < 1000) {
          num = Math.round(item.distance) + "m";
        }
        if (item.distance >= 1000) {
          num = (item.distance / 1000).toFixed(1) + "km";
        }
        if (item.distance >= 500000) {
          num = "";
        }
        item.distance = num;
      }
      if (item.isMultipleStore) {
        item.distance = "";
        item.address = "多店通用";
        item.business = "";
      }
    },
    //价格
    productPrice: function productPrice(item) {
      var val = Number(item.minPrice || "");
      item.priceInt = Math.floor(val);
      item.priceFloat = String(val).match(/\d+(\.\d+)/) ? String(val).match(/\d+(\.\d+)/)[1] : "";
      if (item.priceInt && Number(item.priceInt) > 1000) {
        item.priceFloat = "";
      }
    },
    //推广奖励
    productComm: function productComm(item) {
      var that = this;
      item.commText = "";
      item.commType = 1;
      item.smallFont = false;
      item.hasAppComm = false;
      function hasValue(val) {
        val = val ? val + "" : "";
        val = val.replace(/¥|￥|%/g, "");
        if (val == 0) {
          return false;
        }
        return true;
      }
      function getValue(val) {
        val = val + "";
        if (val.indexOf("%") >= 0) {
          item.commType = 2;
          val = that.$options.filters["filterCommKeepOne"](Number(val.replace(/¥|￥|%/g, "")));
          item.earnInt = Math.floor(val);
          item.earnFloat = String(val).match(/\d+(\.\d+)/) ? String(val).match(/\d+(\.\d+)/)[1] : "";
          return '<span class="price-num">' + val + "</span><i>%</i>";
        } else {
          val = that.$options.filters["filterCommKeepOne"](Number(val.replace(/¥|￥|%/g, "")));
          item.earnInt = Math.floor(val);
          item.earnFloat = String(val).match(/\d+(\.\d+)/) ? String(val).match(/\d+(\.\d+)/)[1] : "";
          return '<i>￥</i><span class="price-num">' + val + "</span>";
        }
      }
      item.commText += hasValue(item.maxCommission) ? getValue(item.maxCommission) : "";
      if (item.earnInt && Number(item.earnInt) >= 100 && item.earnFloat) {
        item.earnFloat = item.earnFloat[1] > 0 ? "." + item.earnFloat[1] : "";
      }
      if (!item.commText) {
        item.isOpenMemberCommission = 0;
      }
    },
    toProductAddress: function toProductAddress(item) {
      var that = this;
      var link = this.getProductLink(item);
      that.saveOldData(item.saveItemId);
      window.YCF_Plugin.reportUserAnchors({
        event_id: "540014",
        properties: {
          item_id: item.goodsId,
          product_category: that.isGoodsDetails(link) ? "scenic" : "product",
          source: "myShop"
        }
      }).always(function () {
        window.location.href = link;
      });
    },
    //获取产品对应的链接
    getProductLink: function getProductLink(product) {
      var urlStr = _getProductLink(product, 'h5');
      var isGoodsDetails = this.isGoodsDetails(urlStr);
      urlStr = urlStr + toQueryString({
        scenicFrom: isGoodsDetails ? "myShop" : null,
        channel: isGoodsDetails ? null : "myShop",
        showAllWechat: isGoodsDetails ? "1" : null
      });
      return urlStr;
    },
    isGoodsDetails: function isGoodsDetails(url) {
      return url && (url.indexOf("/front/platform/goodsDetails") >= 0 || url.indexOf("/front/platform/storeDetails") >= 0);
    },
    //初始化倒计时时间
    initProductTime: function initProductTime(item) {
      item.startRemainTime = item.startTime - item.serverTime;
      item.endRemainTime = item.endTime - item.serverTime;
      item.timeText = "";
      this.setCountDownText(item);
    },
    //设置倒计时文案
    setCountDownText: function setCountDownText(item) {
      function setTimeText(item) {
        var status = item.status,
          // targetTime = item.status == 1 ? item.startTime : item.endTime,
          targetTimeObj = item.status == 1 ? item.startTimeObj : item.endTimeObj,
          RemainTime = item.status == 1 ? item.startRemainTime : item.endRemainTime,
          statusText = item.status == 1 ? "开抢" : "结束",
          timeObj = getTimeOject(RemainTime),
          timeText = "<span>" + statusText + "日期&nbsp</span><span class='num'>" + (targetTimeObj.month > 9 ? targetTimeObj.month : "0" + targetTimeObj.month) + "</span><span>-</span><span class='num'>" + targetTimeObj.day + "</span>";
        if (timeObj.day < 1 && (status == 1 || status == 2)) {
          if (timeObj.day < 1) {
            timeText = "<span>距" + statusText + "&nbsp</span><span class='num'>" + timeObj.hour + "</span><span>:</span><span class='num'>" + timeObj.minute + "</span><span>:</span><span class='num'>" + timeObj.second + "</span>";
          }
        }
        return timeText;
      }
      //1活动未开始
      if (item.startRemainTime > 0) {
        item.status = 1;
        item.timeText = setTimeText(item);
      }
      //2活动抢购中/即将结束
      if (item.startRemainTime <= 0 && item.endRemainTime >= 0) {
        item.status = 2;
        item.timeText = setTimeText(item);
      }
      //2活动已结束
      if (item.endRemainTime <= 0) {
        item.status = 3;
        item.timeText = setTimeText(item);
      }
      item.startRemainTime = item.startRemainTime - (this.nowTimeStame - this.beforeTimeStame);
      item.endRemainTime = item.endRemainTime - (this.nowTimeStame - this.beforeTimeStame);
    },
    // 店铺精选删除
    removeCarefully: function removeCarefully(option) {
      var that = this;
      that.editCareFully({
        productId: option.item.goodsId,
        activityId: option.item.activityId,
        isTop: 0,
        isCollect: 0
      }, function () {
        that.getCarefullyProductList();
        //that.carefullyData.removeNum++;//取消分页不用记
      });
    },

    // 店铺精选置顶
    toTopCarefully: function toTopCarefully(option) {
      var that = this;
      that.editCareFully({
        productId: option.item.goodsId,
        activityId: option.item.activityId,
        isTop: option.item.isTop == 0 ? 1 : 2,
        isCollect: 1
      }, function () {
        toast(option.item.isTop == 0 ? "置顶成功" : "取消置顶成功");
        that.getCarefullyProductList();
      });
    },
    //编辑点评精选
    editCareFully: function editCareFully(ajaxData, cd) {
      var that = this;
      databus({
        origin: Origins.API_GOOD,
        url: "/api/products/shopCollection",
        noLongLatitude: true,
        data: $.extend(ajaxData, {
          province: that.currentCity.provinceName,
          district: that.currentCity.districtName,
          city: that.currentCity.cityName
        }),
        success: function success(data) {
          if (data.code === 1000 && data.bcode === 100) {
            cd(data.content);
          } else {
            toast(data.message);
          }
        },
        error: function error() {
          toast("网络有误，请刷新重试");
        },
        beforeSend: function beforeSend() {
          showLoading();
        },
        complete: function complete() {
          hideLoading();
        }
      });
    },
    //倒计时
    initCountDown: function initCountDown() {
      var that = this;
      var i = 0;
      var j = 0;
      that.beforeTimeStame = Date.parse(new Date()) / 1000;
      that.nowTimeStame = that.beforeTimeStame + 1;
      that.timer = setInterval(function () {
        that.nowTimeStame = Date.parse(new Date()) / 1000;
        for (i = 0; i < that.countDownList.length; i++) {
          that.setCountDownText(that.countDownList[i]);
        }
        for (j = 0; j < that.product.list.length; j++) {
          var item = that.product.list[j];
          if (item.staus == 3) {
            that.product.list.splice(j, 1);
            j--;
          }
        }
        that.beforeTimeStame = that.nowTimeStame;
      }, 1000);
    },
    //判断城市名是否相同
    theSameCity: function theSameCity(oneCity, twoCity) {
      oneCity = String(oneCity || "");
      twoCity = String(twoCity || "");
      return oneCity && twoCity && oneCity.replace(/(市*$)/g, "") == twoCity.replace(/(市*$)/g, "");
    },
    //判断改产品是否可展示(去重)
    canAddThisProduct: function canAddThisProduct(list, product) {
      var productList = list.slice(-40);
      return productList.find(function (item) {
        return item.goodsId == product.goodsId && item.activityId == product.activityId;
      }) ? false : true;
    },
    setShare: function setShare() {
      if (this.shopPromotion) {
        var shareObj = {
          imgUrl: "https://qiniu-cdn7.jinxidao.com/dvb/frontv2/images/logo.png",
          descContent: "精选特价限时抢购，快来看看吧~",
          lineLink: updateUrlParam(window.location.href, "inPreview", ""),
          shareTitle: this.shopName + " - 订酒店5折、景区门票7折、周边美食餐饮优选好物1折起"
        };
        window.defShareObj = shareObj;
        YCF_Plugin.setWeiXinShare(shareObj, this.shopPromotion);
      }
    }
  },
  mounted: function mounted() {
    var that = this;
    that.checkShopkeeper();
    that.getShopName();
    that.initCountDown();
  }
};
export default page;